module.exports = __webpack_public_path__ + "img/info.b7cc032.png";


//////////////////
// WEBPACK FOOTER
// ./assets/assistant/info.png
// module id = ./assets/assistant/info.png
// module chunks = 10